import { PersonalInfoFormActionType, useCheckoutRequest } from "app/hooks";
import { useUpdateCartFromInfo } from "app/hooks/checkout/useUpdateCartFromInfo";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useStandardProductType } from "app/hooks/shared/standard-product/useStandardProductType";
import { useCartContext } from "app/providers/CartProvider";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { useInfoFormErrorsContext } from "pages/checkout/providers/InfoFormErrorsProvider";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";
import { honeyPotToken } from "../info-inputs/components/HiddenInput";

const CheckoutInfoFooter = () => {
  const cartContext = useCartContext();
  const cart = cartContext.getCart();

  const { updateCartFromInfo } = useUpdateCartFromInfo();
  const { onAddShippingInfo, onAddStandardProductShippingInfo } =
    useAnalytics();
  const { mutateCheckout, isCheckoutRequestLoading } = useCheckoutRequest();
  const { updateCurrentTab } = useCheckoutTabsContext();
  const { dispatch, state } = useCheckoutInfoContext();
  const { getFormErrors, setFormErrors, isFormValid } =
    useInfoFormErrorsContext();
  const productAnalysis = useStandardProductType(cart);

  const setIsSubmittingInfo = () => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_IS_SUBMITTING,
      payload: true,
    });
  };

  const onPlanDoorAppointmentClick = () => {
    onAddShippingInfo(cart, cartContext.getVoucherDisplay());
    updateCartFromInfo();

    const honeyPot = localStorage.getItem(honeyPotToken);

    // If the honey pot is filled, do not proceed with the checkout
    if (!honeyPot) {
      mutateCheckout();
    }
  };

  const onPlanStandardProductAppointmentClick = () => {
    onAddStandardProductShippingInfo(cart, cartContext.getVoucherDisplay());
    updateCartFromInfo();

    // If its ACOUSTIC PANEL flow: next tab should be APPOINTMENT * /
    // if its ACCESOIRE flow: next tab should be PAYMENT * /
    const nextTab =
      productAnalysis.someAkoestischepanelen ||
      productAnalysis.someAccessoireAkoestischPaneel
        ? CheckoutTabIds.APPOINTMENT
        : CheckoutTabIds.PAYMENT;
    updateCurrentTab(nextTab);
  };

  const handlePlanAppointmentClick = () => {
    setIsSubmittingInfo();

    if (!isFormValid()) {
      setFormErrors(getFormErrors());
      return;
    }

    if (cart.products.length) {
      onPlanDoorAppointmentClick();
    } else if (cart.standardProducts && cart.standardProducts.length) {
      onPlanStandardProductAppointmentClick();
    }
  };

  const onOverviewClick = () => {
    updateCurrentTab(CheckoutTabIds.OVERVIEW);
  };

  return (
    <footer
      className={concatClassnames(
        "gg-px-4 sm:gg-px-14 md:gg-px-16 lg:gg-px-14 xl:gg-px-14",
        "gg-grid gg-gap-y-5 gg-bg-dark-blue gg-py-11 gg-text-white",
        "gg-items-center sm:gg-flex sm:gg-justify-between sm:gg-gap-x-8",
      )}
    >
      <Button
        type={ButtonTypes.WHITE}
        arrow={ButtonArrowTypes.LEFT}
        onClick={() => onOverviewClick()}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-px-5 gg-py-3 lg:gg-w-fit lg:gg-max-w-xs xl:gg-py-3.5"
      >
        Terug naar overzicht
      </Button>

      <Button
        onClick={() => handlePlanAppointmentClick()}
        type={ButtonTypes.YELLOW}
        arrow={ButtonArrowTypes.RIGHT}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-px-5 gg-py-3 lg:gg-w-fit lg:gg-max-w-xs lg:gg-px-8 xl:gg-py-3.5"
        loading={isCheckoutRequestLoading}
        disabled={isCheckoutRequestLoading}
        data-testid="order-proceed-button"
      >
        {cart.standardProducts.length === 0 && cart.products.length !== 0
          ? !cart.isSelfAssembly
            ? "Plan je gratis afspraak"
            : "Plan je bezorgafspraak"
          : "Verder"}
      </Button>
    </footer>
  );
};
export default CheckoutInfoFooter;
